<div class="declaration-container" [formGroup]="formGroup">

  <!-- Title -->
  <!-- <h5 class="section-title">Declaration</h5> -->

  <!-- Declaration Text -->
  <p class="note">
    <b>IMPORTANT: The information disclosed in this application form forms the basis for Professional Investment
      Advisory Services Pte Ltd (PIAS)’s submission to the Monetary Authority of Singapore (MAS) under its
      Representative Notification Framework. False declaration or material non-disclosure of information may render a
      representative to be not fit and proper. PIAS reserves the right to review your representative's agreement if any
      false declaration or material non-disclosure is detected.</b>
  </p>
  <div class="declaration-list">

    <ol>
      @for (item of declarations; track $index) {
      <li>
        {{ item}}
      </li>
      }
    </ol>

  </div>

  <!-- Checkbox -->
  <mat-checkbox formControlName="declarationAccepted">
    I agree to the above declaration
  </mat-checkbox>

  <!-- Error -->
  <div class="error"
    *ngIf="formGroup.get('declarationAccepted')?.touched && formGroup.get('declarationAccepted')?.invalid">
    You must accept the declaration to continue
  </div>

  <!-- Name & Date -->
  <div class="row g-3 mt-2">

    <div class="col-md-5">
      <mat-label>Full Name</mat-label>
      <mat-form-field class="w-100">

        <input matInput formControlName="declarantName" readonly />
      </mat-form-field>
    </div>

    <div class="col-md-5">
      <mat-label>Date</mat-label>
      <mat-form-field class="w-100">

        <input matInput type="date" formControlName="declarationDate" readonly />
      </mat-form-field>
    </div>
    <mat-error>
      @if(this.message != '') {
      <span>{{message}}</span>
      }
      @else {
      <span></span>
      }
    </mat-error>
  </div>
  @if(readonly() === false){
  <!-- Form Actions -->
  <div class="form-actions">

    <button class="save-btn" (click)="submit()" [disabled]="formGroup.invalid">

      <span>Submit</span>
      <!-- <mat-icon>arrow_forward</mat-icon> -->

    </button>

  </div>
}

  <!-- Submit -->
  <!-- <div class="text-end mt-3">
    <button mat-raised-button color="primary" (click)="submit()">
      Submit Application
    </button>
  </div>

</div> -->